const optionsDataAndSms = {
  scales: {
    yAxes: [
      {
        id: 'A',
        ticks:{
          min: 0,
          callback: function(value, index, values) {
              return value.toFixed(0);
          },
        },
        maintainAspectRatio: false,
        type: 'linear',
        position: 'left',
        
        scaleLabel: {
          display: true,
          labelString: '(Data (MB',
        },
        gridLines: {
          display: false,
        },
        stacked: true,
      },
      {
        id: 'B',
        ticks: {
          min: 0,
        },
        type: 'linear',
        position: 'right',
        scaleLabel: {
          display: true,
          labelString: 'SMS (%)',
        },
        gridLines: {
          display: false,
        },
        stacked: true,
      },
    ],
  },
}

const optionsData = {
  scales: {
    yAxes: [
      {
        id: 'A',
        ticks:{
          min: 0,
          callback: function(value, index, values) {
              return value.toFixed(0);
          },
        },
        type: 'linear',
        position: 'left',
        scaleLabel: {
          display: true,
          labelString: '(Data (MB',
        },
        gridLines: {
          display: false,
        },
      },
    ],
  },
}

const optionsSms = {
  scales: {
    yAxes: [
      {
        id: 'A',
        ticks: {
          min: 0
        },
        type: 'linear',
        position: 'left',
        scaleLabel: {
          display: true,
          labelString: 'SMS (%)'
        },
        gridLines: {
          display: false
        }
      }
    ]
  }
}

function clone (o) {
  return JSON.parse(JSON.stringify(o))
}

export function getOptionsDataAndSms () {
  return clone(optionsDataAndSms)
}

export function getOptionsData () {
  return clone(optionsData)
}

export function getOptionsSms () {
  return clone(optionsSms)
}



// WEBPACK FOOTER //
// ./src/pages/subscriptions/containers/graph-options.js